module.exports = __webpack_public_path__ + "img/planner-filter.a148eb63.svg";